"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.QuillToolbar = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _span, _span2, _span3, _span4, _span5, _span6;
const QuillToolbar = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    id: "toolbar",
    children: [_span || (_span = /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "ql-formats",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
        className: "ql-font",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "arial",
          children: "Arial"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "comic-sans",
          children: "Comic Sans"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "courier-new",
          children: "Courier New"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "georgia",
          children: "Georgia"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "helvetica",
          children: "Helvetica"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "lato",
          children: "Lato"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "lucida",
          children: "Lucida"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "montserrat",
          children: "Montserrat"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "noto-sans",
          children: "Noto Sans"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "open-sans",
          children: "Open Sans"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "poppins",
          children: "Poppins"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "roboto",
          children: "Roboto"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "segoe-ui",
          children: "Segoe UI"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "source-sans-pro",
          children: "Source Sans Pro"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "times-new-roman",
          children: "Times New Roman"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "trebuchet-ms",
          children: "Trebuchet MS"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "verdana",
          children: "Verdana"
        })]
      })
    })), _span2 || (_span2 = /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "ql-formats",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
        className: "ql-header",
        defaultValue: "3",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "1",
          children: "Heading"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "2",
          children: "Subheading"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "3",
          children: "Normal"
        })]
      })
    })), _span3 || (_span3 = /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "ql-formats",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: "ql-bold"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: "ql-italic"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: "ql-underline"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: "ql-strike"
      })]
    })), _span4 || (_span4 = /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "ql-formats",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: "ql-list",
        value: "ordered"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: "ql-list",
        value: "bullet"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: "ql-indent",
        value: "-1"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: "ql-indent",
        value: "+1"
      })]
    })), _span5 || (_span5 = /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "ql-formats",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("select", {
        className: "ql-align"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("select", {
        className: "ql-color"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("select", {
        className: "ql-background"
      })]
    })), _span6 || (_span6 = /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "ql-formats",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: "ql-link"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: "ql-image"
      })]
    })), children]
  });
};
exports.QuillToolbar = QuillToolbar;
var _default = exports.default = QuillToolbar;